import React from 'react';

import IconButton  from '@mui/material/IconButton';
import Typography  from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const BackButton = ({returnCallback}) => {

  const { t } = useTranslation();

  const styles = {
    button: {
      '&:hover': {
        textDecoration: 'underline',
        backgroundColor: 'transparent'
      },
      '&:focus': {
        textDecoration: 'underline',
        backgroundColor: 'transparent'
      }
    },
    icon: {
      fontSize: '2em'
    }, 
    label: {
      fontSize: '1em',
      marginLeft: '.5em',
      color: '#000000',
    }
  };

  return (
    <IconButton sx={styles.button} onClick={returnCallback} >
      <FontAwesomeIcon style={styles.icon} color='#000000' fill='red' icon={faArrowCircleLeft} />
      <Typography sx={styles.label}>
        {t('common.return-side-bar')}
      </Typography>
    </IconButton>
  );
};